import React, { useState, useEffect, useRef } from "react"
import { _Api } from "../api/_call";
import TableColumnModal from "../common/modules/tableColumn";
import { Tablehead } from "../common/modules/Tablehead";
import { useReportSort } from "./useReportSort";
import { reportpolisthead } from "../common/Tablehead";
import { ReportMenuModal } from "../common/modules/reportMenu";
import "./report.scss";
import { toFormatPrice, toUnformatPrice } from "../common/helpers/function";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SocialModal from "../common/modules/SocialModal/SocialModal";
import { Pagination } from "../common/Pagination";
import ProductModal from "../common/modules/ProductModal";
import { loading, Updateloading } from "../common/helpers/toastify";
import * as FileSaver from 'file-saver';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import Select from "react-select";
const POreport = (props) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const [socialurl, setSocialurl] = useState();
  const [limit, setLimit] = useState(100);
  const [filtername, setFiltername] = useState('');
  const [datefilter, setDatefilter] = useState(() => {
    const start = new Date();
    start.setDate(start.getDate() - 30);
    start.setHours(0, 0, 0, 0);
    return [start, new Date()];
  });
  const [datelable, setDatelable] = useState('LastMonth')
  const datePickerRef = useRef(null)

  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === 'Today') {
      const todayStart = new Date(); todayStart.setHours(0, 0, 0, 0);
      setDatefilter([todayStart, new Date()]); setDatelable('Today');
    } else if (lable === 'Yesterday') {
      const yesterdayStart = new Date(MainDate.setDate(MainDate.getDate() - 1));
      yesterdayStart.setHours(0, 0, 0, 0);
      const yesterdayEnd = new Date(yesterdayStart); yesterdayEnd.setHours(23, 59, 59, 999);
      setDatefilter([yesterdayStart, yesterdayEnd]); setDatelable('Yesterday');
    } else if (lable === '7days') {
      const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7));
      sevendays.setHours(0, 0, 0, 0);
      const todayEnd = new Date(); todayEnd.setHours(23, 59, 59, 999);
      setDatefilter([sevendays, todayEnd]); setDatelable('7days');
    } else if (lable === '30days') {
      const days = new Date(MainDate.setDate(MainDate.getDate() - 30));
      days.setHours(0, 0, 0, 0);
      const todayEnd = new Date(); todayEnd.setHours(23, 59, 59, 999);
      setDatefilter([days, todayEnd]); setDatelable('30days');
    } else if (lable === 'ThisMonth') {
      const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
      firstDay.setHours(0, 0, 0, 0);
      const lastDay = new Date(MainDate.getFullYear(), MainDate.getMonth() + 1, 0);
      lastDay.setHours(23, 59, 59, 999);
      setDatefilter([firstDay, lastDay]); setDatelable('ThisMonth');
    } else if (lable === 'LastMonth') {
      const start = new Date();
      start.setDate(start.getDate() - 30);
      start.setHours(0, 0, 0, 0);
      setDatefilter([start, new Date()]); setDatelable('LastMonth');
    }
  }

  const [reportpolist, setReportpolist] = useState([]);
  const reportSort = useReportSort(reportpolist, [null, (r) => r?.created_date, (r) => r?.po_no, (r) => r?.SKU, (r) => r?.metal_name, (r) => r?.stone_name, (r) => r?.size_name, (r) => r?.po_QTY_noChange, (r) => r?.final_totals, (r) => r?.supplier, (r) => r?.delivery_Date, (r) => r?.SHIPTO, (r) => r?.customer_name, (r) => r?.statusReport, (r) => r?.created_by, (r) => r?.modifiedBy]);
  const [newcolumndata, setnewcolumndata] = useState(reportpolisthead);
  const [reportpocounts, setReportpocounts] = useState([]);
  const [getoneproduct, setOneproduct] = useState();
  const [shareloader, setShareloader] = useState(false);
  const [datalodaer, setDatsLodaer] = useState(false)
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [state, setstate] = useState({
    totalPages: 0,
    currentPage: 1,
  });
  const { totalPages, currentPage } = state;
  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Getreportpo(1, limit, search);
  }
  const getlimit = (nextLimit) => {
    setLimit(nextLimit);
    Getreportpo(1, nextLimit);
    setstate({ ...state, currentPage: 1 });
  };
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getreportpo(current, "");
  };
  useEffect(() => {
    callcolumns();
  }, []);

  const getprintpo = async () => {
    let GetloadingID = loading();

    try {
      const postdata = {
        "search": filtername,
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : ""
      };
      let res = await _Api(postdata, `api/v1/Inventory/reports/print/PurchaseOrder`);

      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement('a');
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute('target', '_blank');
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50)
        setSocialurl(res?.link);
      } else {
        Updateloading(t, GetloadingID, res?.message ? (res?.message) : (res?.errors), 'error');
      }
    }

    catch (err) {
      console.log(err, 'err');
      Updateloading(t, GetloadingID, err, t('error'));
    }


  }
  const getsharepo = async () => {
    setShareloader(true);
    try {
      const postdata = {
        "search": filtername,
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : ""
      };
      let res = await _Api(postdata, `api/v1/Inventory/reports/print/PurchaseOrder`);

      if (res.code === 200) {
        setSocialurl(res?.link);
        setShareloader(false);
      }
    }
    catch (err) {
      console.log(err, 'err');
    }

  }
  const Getreportpo = async (current, firstlimit, search) => {
    setDatsLodaer(true)
    const tablelimit = firstlimit ? firstlimit : limit;
    const skipNumber = current ? (current - 1) * (Number(tablelimit) || 0) : 0;
    try {
      const postdata = {
        "search": search === "" ? search : (search || filtername || ""),
        "limit": firstlimit ? firstlimit : limit,
        "skip": skipNumber,
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : ""
      };
      let res = await _Api(postdata, `api/v1/Inventory/report/purchaseorder`);
      if (res.code === 200) {
        const rows = res?.data || [];
        const page = current ? Number(current) : 1;
        const pageini = Number(postdata.limit) || rows.length || 1;
        const hasApiTotal = res?.total !== undefined && res?.total !== null && res?.total !== "";
        setReportpolist(rows);
        setReportpocounts(res?.counts);
        if (!rows.length && page > 1 && !hasApiTotal) {
          setstate((prev) => ({
            ...prev,
            totalPages: page - 1,
            currentPage: page - 1,
          }));
        } else {
          setstate((prev) => {
            let totalPages = 0;
            if (hasApiTotal) {
              totalPages = Math.ceil((Number(res?.total) || 0) / pageini) || 0;
            } else if (!rows.length) {
              totalPages = 0;
            } else if (rows.length < pageini) {
              totalPages = page;
            } else if (page === 1) {
              totalPages = 2;
            } else {
              totalPages = Math.max(prev.totalPages || 0, page + 1);
            }
            return { ...prev, totalPages, currentPage: page };
          });
        }

      } else {
        // "data not found" -> nothing in this range; clear the old rows
        setReportpolist([]);
        setReportpocounts([]);
        setstate((prev) => ({ ...prev, totalPages: 0, currentPage: 1 }));
      }
      setDatsLodaer(false)
    }
    catch (err) {
      console.log(err, 'err');
      setDatsLodaer(false);
    }
  }
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_report_po",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      Getreportpo();
    }
    // eslint-disable-next-line
  }, [datefilter]);

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".po-report-page");
    const apply = () => {
      if (!page) return;
      page.style.setProperty(
        "--report-sticky-block-height",
        `${el.offsetHeight}px`,
      );
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  const syncPoTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") {
      body.scrollLeft = head.scrollLeft;
    } else {
      head.scrollLeft = body.scrollLeft;
    }
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  useEffect(() => {
    let frame = 0;
    const syncPoTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;

        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const count = headThs.length;
        if (!count) return;

        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });

        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, 40)));
        }
        let total = widths.reduce((sum, w) => sum + w, 0);
        const containerWidth = Math.floor(
          tableBodyScrollRef.current?.clientWidth ||
            tableHeadScrollRef.current?.clientWidth ||
            0,
        );
        if (containerWidth > total && total > 0) {
          const scale = containerWidth / total;
          let used = 0;
          for (let i = 0; i < count; i += 1) {
            if (i === count - 1) {
              widths[i] = Math.max(widths[i], containerWidth - used);
            } else {
              widths[i] = Math.max(1, Math.floor(widths[i] * scale));
              used += widths[i];
            }
          }
          total = containerWidth;
        }
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;

        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable
            .querySelectorAll(`tr > :nth-child(${i + 1})`)
            .forEach((cell) => {
              cell.style.width = widthPx;
              cell.style.minWidth = widthPx;
              cell.style.maxWidth = widthPx;
            });
        }

        (newcolumndata || []).forEach((col, index) => {
          const hide = col?.status === false;
          headThs[index]?.classList.toggle("d-none", hide);
          bodyTable
            .querySelectorAll(`tr > :nth-child(${index + 1})`)
            .forEach((cell) => {
              cell.classList.toggle("d-none", hide);
            });
        });
      });
    };

    syncPoTableWidths();
    window.addEventListener("resize", syncPoTableWidths);
    const observer = new ResizeObserver(syncPoTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncPoTableWidths);
      observer.disconnect();
    };
  }, [reportpolist, newcolumndata, datalodaer]);

  const downloadexclsheet = async () => {
    let header_values = [];
    let bodyarray = [];
    reportpolisthead.forEach(async (r, k) => {
      header_values.push(r?.lable)
    })
    if (reportpolist.length) {
      reportpolist.forEach((result, key) => {
        bodyarray.push([key + 1, result?.created_date, result?.po_no, result?.SKU, result?.metal_name, result?.stone_name, result?.size_name, result?.po_QTY_noChange, result?.final_totals, result?.delivery_Date, result?.SHIPTO, result?.customer_name, result?.statusReport === 1 ? "Completed" : result?.statusReport === 2 ?
          "Pending"
          : result?.statusReport === 3 ?
            "Approved"
            : "Canceled", result?.created_by, result?.modifiedBy])
      })
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(bodyarray, { origin: 'A2', skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: 'A1' });
    XLSX.utils.book_append_sheet(wb, ws, 'Records');
    const fileContent = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([fileContent], { type: fileType });
    FileSaver.saveAs(data, "poreport");
  }
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]
  return (
    <React.Fragment>
      <div className="main-body report-page po-report-page product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="sticky-top-report-page" ref={stickyTopRef}>
              <h2 className="main-body-heading"><span>{t("report")} {">"}</span>&nbsp;&nbsp;{t("Purchase Order")}</h2>
              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/free-stock.png"}
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t("Total Qty")}</span>
                      <h2 className="inventory-value stock">{reportpocounts?.totalQty ? reportpocounts?.totalQty : 0}</h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/sku.png"}
                        className="inventory-img"
                        alt="sku"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t("Sku")}</span>
                      <h2 className="inventory-value sku">{reportpocounts?.uniqueCountSKU ? reportpocounts?.uniqueCountSKU : 0}</h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/location.png"}
                        className="inventory-img"
                        alt="value"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t("Location's From")}</span>
                      <h2 className="inventory-value location">{reportpocounts?.uniqueCountshipTo ? reportpocounts?.uniqueCountshipTo : 0}</h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/value.png"}
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t("Total Value")}</span>
                      <h2 className="inventory-value value">{reportpocounts?.totalValue ? reportpocounts?.totalValue : 0}</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main-body-top-status-bar">
                <ReportMenuModal />
                <Select
                  className="limit-select short z-10"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    getlimit(e.value);
                  }}
                />
                <div className="main-body-top-status-bar-filter">
                  <input
                    value={filtername}
                    type="text"
                    className="main-body-top-status-bar-filter-input"
                    placeholder={t("Search by SKU, Customer")}
                    onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                    onChange={(e) => setFiltername(e.target.value)}
                  />
                  {filtername ? <img className="main-body-top-status-bar-filter-clear" src={base_assets + 'images/icons/False.png'} onClick={(e) => { setFiltername(""); filterbyname("") }} alt="" /> : ""}
                  <button onClick={() => filterbyname(filtername)} className="main-body-top-status-bar-filter-search">
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
                <div className="main-body-top-status-bar-multi-date-picker">
                  <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                    <button className="dropdown-toggle btn-style align-items-center d-flex" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      {t(datelable)}
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right-fix" aria-labelledby="dropdownMenuButton1">
                      <li className={`dropdown-item ${datelable === 'Today' ? "active" : ""}`} onClick={() => changeDates('Today')}>{t("Today")}</li>
                      <li className={`dropdown-item ${datelable === 'Yesterday' ? "active" : ""}`} onClick={() => changeDates('Yesterday')}>{t("Yesterday")}</li>
                      <li className={`dropdown-item ${datelable === '7days' ? "active" : ""}`} onClick={() => changeDates('7days')}>{t("Last 7 days")}</li>
                      <li className={`dropdown-item ${datelable === '30days' ? "active" : ""}`} onClick={() => changeDates('30days')}>{t("Last 30 days")}</li>
                      <li className={`dropdown-item ${datelable === 'ThisMonth' ? "active" : ""}`} onClick={() => changeDates('ThisMonth')}>{t("This Month")}</li>
                      <li className={`dropdown-item ${datelable === 'LastMonth' ? "active" : ""}`} onClick={() => changeDates('LastMonth')}>{t("Last Month")}</li>
                      <li className={`dropdown-item ${datelable === 'Custom Range' ? "active" : ""}`} onClick={() => datePickerRef.current.setOpen(true)}>{t("Custom Range")}</li>
                    </ul>
                    <DatePicker
                      selectsRange={true}
                      monthsShown={2}
                      startDate={datefilter[0]}
                      endDate={datefilter[1]}
                      onChange={(update) => {
                        const startDate = update[0];
                        const endDate = update[1];
                        setDatelable("Custom Range");
                        if (startDate && endDate) {
                          const modifiedStartDate = new Date(startDate);
                          modifiedStartDate.setHours(0, 0, 0, 0);
                          const modifiedEndDate = new Date(endDate);
                          modifiedEndDate.setHours(23, 59, 59, 999);
                          setDatefilter([modifiedStartDate, modifiedEndDate]);
                        } else {
                          setDatefilter([startDate, endDate]);
                        }
                      }}
                      dateFormat="yyyy-MM-dd"
                      ref={datePickerRef}
                      autoComplete='none'
                    />
                  </div>
                  <button className="print-export-dropdown-selected-icon d-none">
                    <img
                      src={base_assets + "images/icons/printer-icon.png"}
                      alt=""
                    />
                  </button>
                  <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={base_assets + "images/icons/ellipsis-circular.png"}
                        alt=""
                      />
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li className={parmissiondatashow?.inventory_reports?.Print ? "dropdown-item print-dropdown-item" : "d-none"} onClick={(e) => { getprintpo(e.target.value); }}>
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/printer-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("Print")}</span>
                      </li>
                      <li className="dropdown-item" onClick={() => downloadexclsheet()}>
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/export-x-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("export")}</span>
                      </li>



                      <li className="dropdown-item" data-bs-toggle="modal" data-bs-target="#socialModal" onClick={() => getsharepo()}>
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/share-icon.png"}
                            alt=""
                          />
                        </div>
                        <span >{t("share")}</span>
                      </li>


                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#columnModal"
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/column-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("column")}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative report-sticky-table-wrap"
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  overflow: "visible",
                }}
              >
                <div className="report-sticky-thead">
                  <div
                    className="report-table-hscroll report-table-hscroll--head"
                    ref={tableHeadScrollRef}
                    onScroll={() => syncPoTableScroll("head")}
                  >
                    <table
                      ref={tableHeadTableRef}
                      className="stripe row-border order-column common-table table-striped main-table report-head-table"
                    >
                      <Tablehead
                        tablehead={newcolumndata}
                        tblName={"tbl_report_po"}
                        setfilterby={""}

                        onSort={reportSort.handleSort}

                        sortConfig={reportSort.sortConfig}
                      />
                    </table>
                  </div>
                </div>
                <div
                    className="report-table-hscroll report-table-hscroll--body"
                    ref={tableBodyScrollRef}
                    onScroll={() => syncPoTableScroll("body")}
                  >
                  <table
                    id="report_pos"
                    ref={tableBodyTableRef}
                    className="stripe row-border order-column common-table table-striped main-table w-100"
                  >
                    <tbody>
                      <>
                        {reportSort.sortedList ? reportSort.sortedList.map((result, key) => {
                          return (
                            <tr className="table align-middle" key={key}>
                              <td className="fixed-side">{(currentPage - 1) * (Number(limit) || 0) + key + 1}</td>
                              <td className="fixed-side">{result?.created_date ? result?.created_date : ''}</td>
                              <td className="fixed-side link-color">{result?.po_no ? result?.po_no : ''}</td>
                              <td className="fixed-side link-color cursor-pointer" onClick={() => setOneproduct(result)} data-bs-toggle="modal" data-bs-target="#ProductInfoModal">{result?.SKU ? result?.SKU : ''}</td>
                              <td className="fixed-side">{result?.metal_name ? result?.metal_name : ''}</td>
                              <td className="fixed-side">{result?.stone_name ? result?.stone_name : ''}</td>
                              <td className="fixed-side">{result?.size_name ? result?.size_name : ''}</td>
                              <td className="fixed-side">{result?.po_QTY_noChange ? result?.po_QTY_noChange : ''}</td>
                              <td className="fixed-side">{result?.final_totals ? result?.final_totals : ''}</td>
                              <td className="fixed-side"><div className="tooltip-area-up"><div className="truncate-text-subtable">{result?.supplier ? result?.supplier : ''}</div>{result?.supplier && <span className="tooltip-area-up-text text-white">{result?.supplier}</span>}</div></td>
                              <td className="fixed-side">{result?.delivery_Date ? result?.delivery_Date : ''}</td>
                              <td className="fixed-side">{result?.SHIPTO ? result?.SHIPTO : ''}</td>
                              <td className="fixed-side">{result?.customer_name ? result?.customer_name : ''}</td>
                              <td className="fixed-side">
                                {
                                  result?.statusReport === 1 ?
                                    <label className="green-neon-text">{t("Completed")}</label>
                                    : result?.statusReport === 2 ?
                                      <label className="yellow-text">{t("Pending")}</label>
                                      : result?.statusReport === 3 ?
                                        <label className="status-green-text">{t("Approved")}</label>
                                        : <label className="danger-text">{t("Canceled")}</label>
                                }
                              </td>
                              <td className="fixed-side">{result?.created_by ? result?.created_by : ''}</td>
                              <td className="fixed-side">{result?.modifiedBy ? result?.modifiedBy : ''}</td>
                            </tr>
                          );
                        }) : ''}
                      </>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td> {reportpolist
                          ? reportpolist?.reduce(
                            (interation, val) =>
                            (interation =
                              interation + parseInt(val.po_QTY_noChange)),
                            0
                          )
                          : ""}</td>

                        <td>
                          {
                            toFormatPrice(reportpolist
                              ? reportpolist?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation +
                                  toUnformatPrice(val?.final_totals)),
                                0
                              )
                              : "", { addSymbol: true })
                          }</td>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                        <td />
                      </tr>
                    </tfoot>
                  </table>
                  </div>
                  <div id="table_loader" className={datalodaer ? "mt-4" : "d-none"}>
                    <div className="dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
              </div>
              {reportpolist?.length > 0 ? (
                <Pagination
                  total={totalPages}
                  current={currentPage}
                  pagination={(crPage) => handlePaginations(crPage)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <SocialModal shareUrl={socialurl} shareloader={shareloader} />
        <ProductModal data_product={getoneproduct} setOneproduct={setOneproduct} editproduct_submit='' />
      </div>
      <TableColumnModal tablehead={reportpolisthead} tblName={"tbl_report_po"} setnewcolumndata={setnewcolumndata}
        calldatatable={Getreportpo}></TableColumnModal>
    </React.Fragment>
  );
};
export default POreport;
